import {ofType, combineEpics} from 'redux-observable';
import {map, mergeMap} from 'rxjs/operators';
import {getKnowNextStep, getDataErrorInfo} from 'redux/knowAction';
import store from 'app/store';

import chnlService from '../api/chnl/chnlService';
import config from '../config/commonConfig';
import {
  RDX_APP_LOGON,
  RDX_APP_LOGOUT,
  RDX_APP_KEEP_ALIVE,
  RDX_APP_SESSIONTIMEOUT_RESET,
  RDX_APP_SAAS,
  saasToken,
  pendingSaas,
  logonFrequency,
  finishApi,
} from '../redux/appAction';
import history from '../app/history';

const getURLSearchParams = (data) => {
  return Object.keys(data)
    .map(function (key) {
      return key + '=' + encodeURIComponent(data[key]);
    })
    .join('&');
};

const constructSaasRequest = (logonState) => {
  let backUrl = window.location.href;
  let postSaaSlogonRedirectUrl = config.saas.postSaaSlogonRedirectUrl;
  let data = {
    channelId: 'WEB',
    countryCode: 'AU',
    functionName: 'Saas_Authentication',
    groupMemberCode: 'HKBA',
    icLaunchBAckURL: postSaaSlogonRedirectUrl + encodeURIComponent(backUrl),
    locale: 'en',
    nextPage: 'SAAS30RESOURCE',
    requestedURI: window.location.href,
    targetCAMLevel: 30,
  };
  let urlParams = getURLSearchParams(data);
  return urlParams;
};

const postSecurityForm = (data) => {
  let formHtml =
    '<form name="navForm" id="navForm" action="' +
    config.saas.saasIpUrl +
    '" method="post" style="display:none"><input name="SAAS_TOKEN_ID" value="' +
    data.artifactId +
    '" type="text"></input><input name="SAAS_TOKEN_ASSERTION_ID" type="text" value="' +
    data.assertionId +
    '" ></input><input id="submitSecurity" type="submit" value="submit"></input></form>';
  document.body.innerHTML = formHtml;
  document.navForm.submit();
};

const LogonEpic = (action$, state$) =>
  action$.pipe(
    ofType(RDX_APP_LOGON),
    mergeMap(
      // @@WP-REACT: customize LOGON step
      // ...
      () =>
        chnlService.gatewayLogon().pipe(
          map((wResponse) => {
            if (wResponse) {
              const {app} = store.getState();
              console.log('app.saasLogonfrequency===', app.saasLogonfrequency);
              if (wResponse.status === 403) {
                // 403: When the resource is forbidden
                if (app.saasLogonfrequency > 5) {
                  window.location.href = config.gsp.bankUrl;
                  return logonFrequency(0);
                } else {
                  let saasfrequency = app.saasLogonfrequency + 1;
                  return saasToken(saasfrequency);
                }
              } else if (wResponse.xhr) {
                let authToken = wResponse.xhr.getResponseHeader('X-authToken');
                // console.log('authToken=====', wResponse.xhr.getAllResponseHeaders(), authToken);
                if (authToken) {
                  store.dispatch(logonFrequency(0));
                  sessionStorage.setItem('BEARER_TOKEN', 'Bearer ' + authToken);
                  return getKnowNextStep('accreditation');
                }
              }
            } else {
              return {type: 'rdx/Done'};
            }
          }),
        ),
    ),
  );

const saasTokenEpic = (action$, state$) =>
  action$.pipe(
    ofType(RDX_APP_SAAS),
    mergeMap((action) =>
      chnlService.saasTokenAuth(constructSaasRequest(action.data)).pipe(
        map((wResponse) => {
          if (wResponse.status === 200) {
            console.log('wResponse.response', wResponse.response);
            postSecurityForm(wResponse.response);
            return pendingSaas();
          } else {
            let errorInfo = '';
            if (wResponse.status) {
              errorInfo = [{code: wResponse.status}];
            }
            history.push('/mistake');
            store.dispatch(finishApi());
            return getDataErrorInfo(errorInfo);
          }
        }),
      ),
    ),
  );

const logOffEpic = (action$) =>
  action$.pipe(
    ofType(RDX_APP_LOGOUT),
    mergeMap(
      // @@WP-REACT: customize LOGOUT step
      // ...
      () =>
        chnlService.gatewayLogoff().pipe(
          map(() => {
            //window.location.href = 'https://www.google.com.hk';
            return {type: 'rdx/Done'};
          }),
        ),
    ),
  );

const keepAlive = (action$) =>
  action$.pipe(
    ofType(RDX_APP_KEEP_ALIVE),
    mergeMap(
      // @@WP-REACT: customize keepalive step
      // ...
      () =>
        chnlService.keepAlive().pipe(
          map(() => {
            return {type: RDX_APP_SESSIONTIMEOUT_RESET};
          }),
        ),
    ),
  );
const appEpic = combineEpics(LogonEpic, saasTokenEpic, logOffEpic, keepAlive);

export default appEpic;
